import Swiper, { A11y, Autoplay, EffectFade, Navigation, Pagination } from 'swiper'

const body  = document.querySelector('body');
const home  = body.classList.contains('home');

if (home) {

    // Slider home
    const homeSlideshow = document.querySelector('.home-slideshow .swiper-container') !== null;

    if (homeSlideshow) {
        let nbSlides = document.querySelectorAll('.home-slideshow .swiper-container .swiper-slide').length;
        let dataSlideAuto = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_auto');
        let dataSlideSpeed = document.querySelector('.home-slideshow .swiper-container').getAttribute('data-slide_speed');
        dataSlideSpeed = dataSlideSpeed + '000';

        Swiper.use([ A11y, Autoplay, EffectFade, Navigation, Pagination ]);
        
        let config = {
            grabCursor : 'true',
            speed: 700,
            loop : true,

            effect : 'fade',
            fadeEffect: {
                crossFade: true,
            },

            // Navigation (arrow)
            navigation: {
                nextEl: `.home-slideshow .swiper-button-next`,
                prevEl: `.home-slideshow .swiper-button-prev`,
            },

            // Pagination (bullet)
            pagination: {
                el: '.slideshow__pagination',
                type: 'bullets', // default
                clickable: true,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                paginationBulletMessage: 'Aller à la diapositive {{index}}',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },
        }

        if(dataSlideAuto === '1'){
            config.autoplay = {
                delay: dataSlideSpeed,
                disableOnInteraction: false,
            }
        }

        if(nbSlides > 1) {
            let swiperHome = new Swiper('.home-slideshow .swiper-container', config);
        }
    }

    // slider Actualités
    const newsSlideshow = document.querySelector('.news .swiper-container') !== null;

    if (newsSlideshow) {
        let newsSlides = document.querySelectorAll('.news .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let newsConfig = {
            effect : 'slide',
            grabCursor : 'true',
            speed: 700,
            loop: false,

            fadeEffect: {
                crossFade: true,
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                nextEl: `.news .swiper-button-next`,
                prevEl: `.news .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            },

            breakpoints: {
                1201: {
                    spaceBetween: 30,
                    slidesPerView: 2,
                },

                961: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                },
                
                641: {
                    spaceBetween: 20,
                    slidesPerView: 2,
                },
        
                0: {
                    spaceBetween: 20,
                    slidesPerView: 1,
                }
            }
        }

        let swiperNews = new Swiper('.news .swiper-container', newsConfig);

        // Fonction pour vérifier la taille de l'écran et le nombre de eventsSlides
        const postsNavigationNews = document.querySelector('.news__navigation');

        function checkScreenSizeNews() {
            const screenSizeNews = window.innerWidth;
            const newsSlides = document.querySelectorAll('.news .swiper-container .swiper-slide').length;
            if (screenSizeNews > 640 && newsSlides <= 2) {
                postsNavigationNews.classList.add('disable');
            } else if (screenSizeNews <= 640 && newsSlides <= 1) {
                postsNavigationNews.classList.add('disable');
            } else {
                postsNavigationNews.classList.remove('disable');
            }
        }

        checkScreenSizeNews();

        window.addEventListener('resize', checkScreenSizeNews);
    }

    // Fil info
    const newsthreadSlideshow = document.querySelector('.newsthread .swiper-container') !== null;

    if (newsthreadSlideshow) {
        let newsthreadSlides = document.querySelectorAll('.newsthread .swiper-container .swiper-slide').length;

        Swiper.use([ A11y, Navigation ]);

        let newsthreadConfig = {
            effect : 'slide',
            grabCursor : 'true',
            speed: 700,
            loop: false,
            spaceBetween: 20,
            slidesPerView: 1,

            fadeEffect: {
                crossFade: true,
            },

            keyboard: {
                enabled: true,
            },

            mousewheel: {
                forceToAxis: true,
                releaseOnEdges : true,
            },

            navigation: {
                nextEl: `.newsthread .swiper-button-next`,
                prevEl: `.newsthread .swiper-button-prev`,
            },

            a11y: {
                enabled: true,
                prevSlideMessage: 'Diapositive précédente',
                nextSlideMessage: 'Diapositive suivante',
                slideLabelMessage: '{{index}} / {{slidesLength}}', // default
            }
        }

        if(newsthreadSlides > 1) {
            let swiperNewsthread = new Swiper('.newsthread .swiper-container', newsthreadConfig);
        }
        
        // Fonction pour vérifier la taille de l'écran et le nombre de eventsSlides
        const postsNavigationNewsthread = document.querySelector('.newsthread__navigation');

        function checkScreenSizeNewsthread() {
            const newsthreadSlides = document.querySelectorAll('.newsthread .swiper-container .swiper-slide').length;
             if (newsthreadSlides <= 1) {
                postsNavigationNewsthread.classList.add('disable');
            } else {
                postsNavigationNewsthread.classList.remove('disable');
            }
        }

        checkScreenSizeNewsthread();

        window.addEventListener('resize', checkScreenSizeNewsthread);
    }
}
